(function() { window.GUID_5cf2a6bb_de70_436e_9804_b52946c13341 = { getGuid: function() { return "5cf2a6bb-de70-436e-9804-b52946c13341"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        class PageContext {
            constructor() {
                CS.Views.PageContext.Instance = this;
            }
            static PageLoaded(controller, action, masterOverlayKey = null) {
                //N'est pas appelé dans le cas dune page en masteroverlay
                console.log(`PageLoaded ${controller} ${action} ${masterOverlayKey}`);
                if (!masterOverlayKey) {
                    CS.Views.MasterPage.Instance.RefreshBody();
                }
                let pageContext = PageContext.Instance;
                let controllerAction = { controllerName: controller, actionName: action };
                if (pageContext.PageLoadedDelegates != null) {
                    for (var i = 0; i < pageContext.PageLoadedDelegates.length; i++) {
                        let delegate = pageContext.PageLoadedDelegates[i];
                        delegate.call(this, pageContext, controllerAction, masterOverlayKey);
                    }
                    pageContext.PageLoadedDelegates.length = 0; //Ceci clear la list
                }
                CS.CSS.DetermineCssFilesCountToTest();
                CS.Views.MasterPage.ApplyLastPageState(false);
            }
            static OnPageLoaded(controllerAction, constructorDelegate) {
                if (controllerAction == null)
                    return;
                PageContext.onPageLoaded(function (pageContext, currentControllerAction, contextKey) {
                    if (pageContext.compareNavigation(currentControllerAction, controllerAction)) {
                        constructorDelegate(contextKey);
                    }
                });
            }
            compareNavigation(currentControllerAction, controllerAction) {
                if (Array.isArray(controllerAction)) {
                    for (var i = 0; i < controllerAction.length; i++) {
                        if (this.compareNavigation(currentControllerAction, controllerAction[i]))
                            return true;
                    }
                    return false;
                }
                let currentControllerName = currentControllerAction.controllerName;
                let currentActionName = currentControllerAction.actionName;
                if (controllerAction.controllerName && controllerAction.actionName) {
                    return controllerAction.controllerName.toLowerCase() == currentControllerName && controllerAction.actionName.toLowerCase() == currentActionName;
                }
                else if (controllerAction.controllerName) {
                    return controllerAction.controllerName.toLowerCase() == currentControllerName;
                }
                else if (controllerAction.actionName) {
                    return controllerAction.actionName.toLowerCase() == currentActionName;
                }
                return false;
            }
            static onPageLoaded(delegate) {
                var pageContext = PageContext.Instance;
                if (pageContext.PageLoadedDelegates == null) {
                    pageContext.PageLoadedDelegates = new Array();
                }
                pageContext.PageLoadedDelegates.push(delegate);
            }
        }
        Views.PageContext = PageContext;
        new CS.Views.PageContext();
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=pagecontext.js.map
